// src/rentals-api-v3/models/CurrencyValue.ts
function CurrencyValueFromJSON(json) {
  return CurrencyValueFromJSONTyped(json, false);
}
function CurrencyValueFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    currencyCode: json["currencyCode"],
    value: json["value"]
  };
}
function CurrencyValueToJSON(json) {
  return CurrencyValueToJSONTyped(json, false);
}
function CurrencyValueToJSONTyped(value, ignoreDiscriminator = false) {
  if (value == null) {
    return value;
  }
  return {
    currencyCode: value["currencyCode"],
    value: value["value"]
  };
}

// src/rentals-api-v3/models/AfterpayConfig.ts
function AfterpayConfigFromJSON(json) {
  return AfterpayConfigFromJSONTyped(json, false);
}
function AfterpayConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    minimumAmount: json["minimumAmount"] == null ? void 0 : CurrencyValueFromJSON(json["minimumAmount"]),
    maximumAmount: json["maximumAmount"] == null ? void 0 : CurrencyValueFromJSON(json["maximumAmount"])
  };
}
function AfterpayConfigToJSON(json) {
  return AfterpayConfigToJSONTyped(json, false);
}
function AfterpayConfigToJSONTyped(value, ignoreDiscriminator = false) {
  if (value == null) {
    return value;
  }
  return {
    minimumAmount: CurrencyValueToJSON(value["minimumAmount"]),
    maximumAmount: CurrencyValueToJSON(value["maximumAmount"])
  };
}

// src/rentals-api-v3/models/PaymentConfig.ts
function instanceOfPaymentConfig(value) {
  if (!("merchantFeeRate" in value) || value["merchantFeeRate"] === void 0) return false;
  return true;
}
function PaymentConfigFromJSON(json) {
  return PaymentConfigFromJSONTyped(json, false);
}
function PaymentConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    merchantFeeRate: json["merchantFeeRate"],
    afterpay: json["afterpay"] == null ? void 0 : AfterpayConfigFromJSON(json["afterpay"])
  };
}
function PaymentConfigToJSON(json) {
  return PaymentConfigToJSONTyped(json, false);
}
function PaymentConfigToJSONTyped(value, ignoreDiscriminator = false) {
  if (value == null) {
    return value;
  }
  return {
    merchantFeeRate: value["merchantFeeRate"],
    afterpay: AfterpayConfigToJSON(value["afterpay"])
  };
}
export {
  PaymentConfigFromJSON,
  PaymentConfigFromJSONTyped,
  PaymentConfigToJSON,
  PaymentConfigToJSONTyped,
  instanceOfPaymentConfig
};
//# sourceMappingURL=PaymentConfig.mjs.map